import { CHATYME_EMBED_HOST_MESSAGE_TYPE, ChatymeEmbedHostMessageTypeValue } from '../constants/chatymeEmbedHostMessageTypes';
import { SocketType } from '../types/socket';

export class ReportHelper {
  static getReportHostMessageType = (
    socketType: SocketType
  ): ChatymeEmbedHostMessageTypeValue | null => {
    switch (socketType) {
      case SocketType.REPORT_LIVE_CHAT_SESSIONS:
        return CHATYME_EMBED_HOST_MESSAGE_TYPE.REPORT_LIVE_CHAT_SESSIONS;
      case SocketType.REPORT_PROMPT_EVAL_RUNS:
        return CHATYME_EMBED_HOST_MESSAGE_TYPE.REPORT_PROMPT_EVAL_RUNS;
      default:
        return null;
    }
  };

  static isReportMessage = (socketType: SocketType) => {
    return ReportHelper.getReportHostMessageType(socketType) != null;
  };
}
